// src/App.jsx

import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./Contexts/AuthContext";
import { Flex, Spinner } from "@chakra-ui/react";
import LoginPage from "./Pages/Login";
import DashboardLayout from "./Layouts/DashboardLayout";
import DashboardHomePage from "./Pages/Dashboard";
import BillingPage from "./Pages/Billing";
import IncludedServicesPage from "./Pages/IncludedServicesPage";
import DocumentsPage from "./Pages/Documents";
import ManualReports from "./Pages/ManualReports";
import SupportPage from "./Pages/Support";
import NewChat from "./Components/NewChat";
import { useContext, useEffect, useState } from "react";
import SocketContext from "./Contexts/SocketContext";
import Helper from "./utils/Helper";
import ServicesPage from "./Pages/Services";
import MaksabReports from "./Pages/MaksabReports";
// import LandingPage from "./Pages/LandingPage/LandingPage.jsx";
import MaintenancePage from "./Components/UnderConstruction";
import { useBranding } from "./Contexts/BrandingContext";
import { useAxios } from "./Hooks";
import authService from "./Services/auth.js";
import { setWafeqCredentials } from "./Api/constants";
import { useSelector } from "react-redux";
import "./Components/NewChat/ChatColors.css";
import TestScroll from "../src/Api/TestScroll.jsx";

const PrivateRoute = ({ children, isLoggedIn, isLoading }) => {
  if (isLoading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

const App = () => {
  useAxios();
  const Socket = useContext(SocketContext);
  const { isLoggedIn, isLoading, login, logout } = useAuth();
  const { OnChange } = useBranding();
  const [checkingToken, setCheckingToken] = useState(true);
  const userAccess = useSelector(
    (state) => state.auth?.user?.accessArray || state.config?.accessArray
  );

  useEffect(() => {
    if (userAccess && userAccess.length > 0) {
      setWafeqCredentials(userAccess);
    }
  }, [userAccess]);

  useEffect(() => {
    const checkTokenValidity = async () => {
      try {
        const user = Helper.GetStorage("User");

        if (user?.UserAccessToken) {
          if (authService.isTokenValid()) {
            // console.log("Token is valid");
          } else {
            await authService.logout();
            if (typeof logout === "function") {
              logout();
            }
          }
        }
      } catch (error) {
        console.error("Token validation error:", error);
      } finally {
        setCheckingToken(false);
      }
    };

    checkTokenValidity();
  }, [logout]);

  // الـ Socket events والكود الحالي
  // useEffect(() => {
  //   const OnNotify = (data, message) => {
  //     console.log("Received notification:", data, message);
  //     const { RoomId: MessageRoomId } = data || {};
  //     if (State?.RoomId != MessageRoomId) {
  //       toast({
  //         title: "New Message",
  //         position: "top",
  //         description: message,
  //         status: "info",
  //         duration: 4000,
  //         isClosable: true,
  //       });
  //     }
  //     Helper.OnNotifyVoice("Message");
  //   };

  //   const HandleSocket = (data) => {
  //     const { command, data: MessageData, message } = data || {};
  //     if (command == "Notify") {
  //       OnNotify(MessageData, message);
  //     }
  //   };

  //   Socket?.on("Message", HandleSocket);
  //   return () => {
  //     Socket?.off("Message", HandleSocket);
  //   };
  // }, [Socket, State?.RoomId, toast]);

  // useEffect(() => {
  //   const HandleClick = () => {
  //     const AudioElement = document.getElementById("Message-Audio");
  //     if (AudioElement) {
  //       AudioElement.play().catch(() => {});
  //     }
  //     document.body.removeEventListener("click", HandleClick);
  //   };
  //   document.body.addEventListener("click", HandleClick);
  //   return () => {
  //     document.body.removeEventListener("click", HandleClick);
  //   };
  // }, [toast]);

  // useEffect(() => {
  //   window.showSheet = function (sheetName) {
  //     const selectedSheet = document.getElementById("sheet-" + sheetName);
  //     if (!selectedSheet) return;

  //     const IsSelected = selectedSheet.style.display == "block";
  //     if (IsSelected) return;

  //     const allSheets = document.querySelectorAll('[id^="sheet-"]');
  //     const allButtons = document.querySelectorAll('[id^="btn-"]');

  //     allSheets.forEach((div) => (div.style.display = "none"));
  //     allButtons.forEach((btn) => (btn.style.backgroundColor = "#244a69ff"));

  //     selectedSheet.style.display = "block";
  //     const selectedButton = document.getElementById("btn-" + sheetName);
  //     if (selectedButton) {
  //       selectedButton.style.backgroundColor = "#051420ff";
  //     }
  //   };
  // }, []);

  useEffect(() => {
    if (!Socket) return;

    const OnVerify = (data) => {
      if (data) {
        if (typeof login == "function") login(data);
      }
    };

    const OnOrganization = (data) => {
      if (data) {
        const { Id, Name } = data || {};
        if (typeof OnChange == "function") {
          const Updated = {};
          if (Name) Updated.Id = Id;
          if (Name) Updated.Name = Name;
          if (Object.keys(Updated).length > 0) OnChange(Updated);
        }
      }
    };

    const OnClient = (data) => {
      if (data?.data) {
        const { command } = data || {};
        const Functions = {
          Verify: OnVerify,
          Organization: OnOrganization,
        };
        if (Functions[command]) Functions[command](data.data);
      }
    };

    Socket?.on("Client", OnClient);
    return () => {
      Socket.off("Client", OnClient);
      Socket.off("disconnect");
    };
  }, [Socket, login, OnChange]);

  if (checkingToken && isLoading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" />
      </Flex>
    );
  }
  const WarpComponent = (Component, Props) => {
    return (
      <PrivateRoute isLoggedIn={isLoggedIn} isLoading={isLoading}>
        <DashboardLayout>
          <Component {...Props} />
        </DashboardLayout>
      </PrivateRoute>
    );
  };

  return (
    <>
      <Routes>
        <Route path="/test-scroll" element={<TestScroll />} />
        {/*  */}
        <Route
          path="/"
          element={
            isLoggedIn ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/login"
          element={
            isLoggedIn ? <Navigate to="/dashboard" replace /> : <LoginPage />
          }
        />
        <Route path="/dashboard" element={WarpComponent(DashboardHomePage)} />
        <Route path="/dashboard/billing" element={WarpComponent(BillingPage)} />
        <Route
          path="/dashboard/documents"
          element={WarpComponent(DocumentsPage)}
        />
        <Route
          path="/dashboard/chat"
          element={WarpComponent(NewChat, {
            Socket,
          })}
        />
        <Route
          path="/dashboard/includedServices"
          element={WarpComponent(IncludedServicesPage)}
        />
        <Route
          path="/dashboard/services"
          element={WarpComponent(ServicesPage)}
        />
        <Route
          path="/dashboard/MaksabReports"
          element={WarpComponent(MaksabReports)}
        />
        <Route
          path="/dashboard/ManualReports"
          element={WarpComponent(ManualReports)}
        />

        {/*  */}
        <Route
          path="*"
          element={
            <Navigate to={isLoggedIn ? "/dashboard" : "/login"} replace />
          }
        />
      </Routes>
    </>
  );
};

export default App;
